import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ErrorType } from '../../api/errorHandling';
import { ToastMessageProps } from '../toast/toastSlice';

export interface IVAZType {
 Id: number;
 ResultId: number;
 ResultTime: string;
 OrderId: number | null;
 OrderTime: string | null;
 State: string;
 DocumentUID: string | null;
 UID: string | null;
 Error: string | null;
 DispatchTime: string;
 ArrivalTime: string;
 Modified: string;
}

interface IVAZState {
 ivaz: IVAZType[];
 loading?: { [key: string]: boolean | null };
 success?: { [key: string]: boolean | null };
}

export interface GetIVAZPayload {
 resultId: number;
}
export interface SendIVAZPayload {
 ResultId: number;
 OrderId?: number | null;
 DispatchTime: string;
 ArrivalTime: string;
}

export const initialState: IVAZState = {
 ivaz: [],
 loading: {},
 success: {},
};

const ivazSlice = createSlice({
 name: 'ivaz',
 initialState,
 reducers: {
  getIVAZStart(state, action: PayloadAction<GetIVAZPayload>) {
   return {
    ...state,
    loading: { ...state.loading, getIVAZ: true },
   };
  },
  getIVAZSuccess(state, action: PayloadAction<IVAZState>) {
   return {
    ...state,
    ivaz: action.payload.ivaz,
    success: { ...state.success, getIVAZ: true },
    loading: { ...state.loading, getIVAZ: null },
   };
  },
  getIVAZFailure(state, action: PayloadAction<ErrorType>) {
   return {
    ...state,
    success: { ...state.success, getIVAZ: false },
    loading: { ...state.loading, getIVAZ: null },
   };
  },
  sendIVAZStart(state, action: PayloadAction<SendIVAZPayload>) {
   return {
    ...state,
    loading: { ...state.loading, sendIVAZ: true },
   };
  },
  sendIVAZSuccess(state, action: PayloadAction<IVAZState & ToastMessageProps>) {
   return {
    ...state,
    success: { ...state.success, sendIVAZ: true },
    loading: { ...state.loading, sendIVAZ: null },
   };
  },
  sendIVAZFailure(state, action: PayloadAction<ErrorType>) {
   return {
    ...state,
    success: { ...state.success, sendIVAZ: false },
    loading: { ...state.loading, sendIVAZ: null },
   };
  },
 },
});
export const {
 getIVAZStart,
 getIVAZSuccess,
 getIVAZFailure,
 //
 sendIVAZStart,
 sendIVAZSuccess,
 sendIVAZFailure,
} = ivazSlice.actions;
export default ivazSlice.reducer;
